import React from "react";
import {
  Card,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Paper as MuiPaper,
  CardContent,
  Box,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import { useDialog } from "../../../../contexts/DialogContext";

import EditDelete from "../../../../components/EditDelete";
import Toolbar from "../../../../components/Toolbar";
import useWindowDimensions from "../../../../utils/windowDimensions";
import AdvanceFilter from "./AdvanceFilter";
import usePlan from "../../../../hooks/usePlan";
import useMainContentDimensions from "../../../../utils/mainContentDimensions";
import DeletePlanModal from "./DeletePlanModal";
import { getTimeStamp } from "../../../../utils/common";
import UserCountList from "./UserCountList";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

const breadCrump = () => {
  return (
    <Breadcrumbs aria-label="Breadcrumb" mt={2}>
      <Typography>Radius</Typography>
      <Typography>Plan</Typography>
      <Typography>List</Typography>
    </Breadcrumbs>
  );
};

const CustomDataGrid = (props) => {
  const { isLoadingDownload, downloadFileType } = usePlan();

  const { height } = useWindowDimensions();
  const { width: mainContentWidth } = useMainContentDimensions();
  const {
    editPage,
    addPage,
    trans,
    rows,
    rowCount,
    isLoading,
    payload,
    setPayload,
    id,
    handleSortModelChange,
    sortModel,
    downloadFile,
    openDownloadDialog,
    refreshPage,
    setFilterResetFunc,
    paginationModel,
    paginationMeta,
    paging,
    onPaginationModelChange,
    permissionKeys,
  } = props;
  console.log(permissionKeys, "ddddddddddddddddder");
  const { openDialog } = useDialog();

  const deleteItemClick = async (planId) => {
    return openDialog(
      "delete_plan",
      "Delete Plan",
      <DeletePlanModal key={getTimeStamp()} planId={planId} refreshPage={refreshPage} />,
    );
  };
  const handleUserCountClick = async (params) => {
    console.log(params, "params56774");
    return openDialog(
      "user_list_count",
      "User List",
      <UserCountList key={getTimeStamp()} planId={params.planId} refreshPage={refreshPage} />,
      "md",
    );
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      filter: false,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e) => {
          e.stopPropagation(); // don't select this row after clicking
          const api = params.api;
          const thisRow = {};
          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach((c) => (thisRow[c.field] = params.getValue(params.id, c.field)));
          console.log(thisRow, "thisRow");
        };
        return (
          <EditDelete
            rowClick={onClick}
            editPage={() => editPage(params.id)}
            deleteItemClick={() => deleteItemClick(params.id)}
            menus={
              permissionKeys && permissionKeys.includes("delete")
                ? permissionKeys
                : [...(permissionKeys || []), "delete"]
            }
          />
        );
      },
    },
    {
      field: "planName",
      headerName: "Plan Name",
      width: 300,
    },
    {
      field: "uploadSpeedName",
      headerName: "Upload Speed",
      width: 130,
    },
    {
      field: "downloadSpeedName",
      headerName: "Download Speed",
      width: 150,
    },
    {
      field: "planType",
      headerName: "Plan Type",
      width: 130,
    },
    {
      field: "planDataType",
      headerName: "Plan Data Type",
      width: 150,
    },
    {
      field: "totalLimitName",
      headerName: "Total Limit",
      width: 130,
    },

    {
      field: "userCount",
      headerName: "Users Count",
      renderCell: (params) => {
        return (
          <Box
            component="span"
            sx={{
              color: "primary.main", // or 'blue'
              textDecoration: "underline",
              "&:hover": { color: "darkblue" }, // Optional hover effect
              cursor: "pointer",
            }}
            onClick={() => handleUserCountClick(params.row)}
          >
            {params.row.userCount}
          </Box>
        );
      },
      width: 130,
    },
    {
      field: "ottPlanName",
      headerName: "OTT Plan Name",
      width: 130,
    },
    {
      field: "status",
      headerName: "status",
      width: 130,
    },
  ];
  const openFilterDialog = () => {
    return openDialog(
      "advance_filter",
      "Advance Filter",
      <AdvanceFilter
        payload={payload}
        setPayload={setPayload}
        setFilterResetFunc={setFilterResetFunc}
      />,
    );
  };
  return (
    <Card sx={{ width: "100%", maxWidth: mainContentWidth - 64 }}>
      <CardHeader
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Stack on small screens
          justifyContent: "space-between",
          alignItems: "flex-start", // Adjust alignment as needed
        }}
        action={
          <Toolbar
            addPage={permissionKeys.indexOf("add") !== -1 ? addPage : null}
            downloadFile={downloadFile}
            openDownloadDialog={openDownloadDialog}
            isLoadingDownload={isLoadingDownload}
            downloadFileType={downloadFileType}
            openFilterDialog={openFilterDialog}
            refreshPage={refreshPage}
            isEnableImport={permissionKeys.includes("upload")}
          />
        }
        title={
          <Typography variant="h6" sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}>
            {trans("plan_list")}
          </Typography>
        }
        subheader={<Box sx={{ display: "flex", flexWrap: "wrap" }}>{breadCrump()}</Box>}
      />
      <CardContent sx={{ height: height - 180, display: "flex", flexDirection: "column" }}>
        <Box sx={{ flex: 1, overflow: "auto" }}>
          {" "}
          <DataGrid
            initialState={{
              pagination: { paginationModel: { pageSize: 100 } },
            }}
            rowCount={rowCount}
            getRowId={(row) => row[id]}
            columns={columns}
            rows={rows}
            page={paging.pageNumber}
            pageSize={paging.pageSize}
            paginationMeta={paginationMeta}
            loading={isLoading}
            pageSizeOptions={[25, 50, 100]}
            paginationMode="server"
            onPaginationModelChange={onPaginationModelChange}
            sortingMode="server"
            sortModel={sortModel}
            onSortModelChange={handleSortModelChange}
            paginationModel={paginationModel}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"
            }
            sx={{
              "& .MuiDataGrid-row.even-row": {
                backgroundColor: "#f9f9f9", // Light gray for even rows
              },
              "& .MuiDataGrid-row.odd-row": {
                backgroundColor: "#ffffff", // White for odd rows
              },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};
CustomDataGrid.propTypes = {
  editPage: PropTypes.func.isRequired,
  addPage: PropTypes.func.isRequired,
  trans: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  rowCount: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  handleSortModelChange: PropTypes.func.isRequired,
  sortModel: PropTypes.object.isRequired,
};
export default CustomDataGrid;
